<template>
	<div class="filter-item detailed-filter">

        <div :class="{ visible: seeDetail }" class="details-options">
            <label v-for="value in item.values" class="checkbox-container">{{ value.name }}
                <input type="checkbox" :name="item.id" :value="value.id" v-model="vmodel">
                <span class="checkmark"></span>
                <HoverInfo v-if="value.description" :text="value.description"/>
            </label>
        </div>

		<a href="#" @click="seeDetail ^= true" class="see-detail">
            {{ item.name }}<span :class="[ seeDetail ? 'arrow-up' : 'arrow-down' ]"></span>
        </a>
	</div>
</template>

<script>
	import HoverInfo from "../../common/HoverInfo";

	export default {
		name: "DetailedFilter",
        data() {
		    return{
                seeDetail: true
            }
        },
		components: {
			HoverInfo
		},
		props: [
			"item",
			"values"
		],
		computed: {
			vmodel: {
				// Parse values object into "vmodel" - array of checked IDs
				get() {
					let x = [];

					Object.keys(this.values).forEach(item => {
						// Let through just values that belong to detailed filter
						if (this.item.values[item])
							x.push(item);
					});

					return x;
				},

				// Emit changes after checkbox change
				set(checkedIds) {
					this.vmodel.forEach(item => {
						// Item was checked but not anymore -> remove
						if (!checkedIds.includes[item])
							this.handleChange(item, null);
					});

					checkedIds.forEach(item => {
						// Item wasn't checked but now is -> add
						if (!this.vmodel.includes[item])
							this.handleChange(item, true);
					});
				}
			}
		},
		methods: {
			// Pass data change to parent component
			handleChange(property, value) {
				this.$emit('input', property, value);
			}
		}
	}
</script>
